import { createSlice } from "@reduxjs/toolkit";

const data = {
  entity: {
    idCatalogo: 0,
    codigo: "",
    descripcion: "",
    abreviado: "",
    orden: 0,
    idPadre: 0,
    descripcionPadre: "",
    estado: "A",
  },
  listPadre: [{ idCatalogo: 0, descripcion: "" }],
  validationActive: {
    descripcion: false,
    idPadre: false,
  },
  validationMessage: [],
}

export const catalogSlice = createSlice({
    name: "catalog",
    initialState: {},
    reducers: {
      init: (state, action) => {
        const { sliceKey } = action.payload;
        if (!state[sliceKey]) state[sliceKey] = JSON.parse(JSON.stringify(data));
      },
      setEntity: (state, action) => {
        const { sliceKey, data } = action.payload;
        state[sliceKey].entity = data;
      },
      setData: (state, action) => {
        const { sliceKey, name, value } = action.payload;

        if (name.startsWith("id")) value = parseInt(value)

        state[sliceKey].entity[name] = value
        state[sliceKey].validationActive[name] = true
      },
      setListPadre: (state, action) => {
        const { sliceKey, data } = action.payload;
        state[sliceKey].listPadre = data;
      },
      setValidationMessage: (state, action) => {
        const { sliceKey, message } = action.payload;
        state[sliceKey].validationMessage = message;
      },
      activeValidations: (state, action) => {
        const { sliceKey } = action.payload;
        Object.keys(state[sliceKey].validationActive).forEach(function (key) {
          state[sliceKey].validationActive[key] = true;
        })
      },
    },
  });

export const { init, setEntity, setData, setListPadre, setValidationMessage, activeValidations
  } = catalogSlice.actions;
export const defaultCatalogo = { ...data.entity };
export default catalogSlice.reducer;